import Constant from '@/const';
import axios from 'axios';

const getAllProcedure = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/procedure'),
      { params },
    );
    return response.data;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getAllProcedure;
